<ng-container *ngIf="isAvailable">
  <div *ngIf="isSwitchAvailable" class="calc-type-group-header__switch">
    <span [innerHTML]="switchProps.labelKey | translate"></span>
    <eds-switch
      [switchId]="switchId"
      [disabled]="false"
      [label]="label"
      [labelOff]="switchProps.labelOffKey | translate"
      [labelOn]="switchProps.labelOnKey | translate"
      [state]="switchState$ | async"
      (switchPressed)="onSwitchPressed($event)"
      ariaLabelledbyStr="calcSwitchLabel"
      labelId="calcSwitchLabel"
    ></eds-switch>
  </div>

  <div
    *ngIf="toggleButtons.length > 0"
    edsFlexbox
    flexWrap="wrap"
    alignItems="flex-end"
  >
    <div *ngIf="label" edsPadding edsPaddingRight="sm" class="small">
      {{ label }}
    </div>
    <eds-toggle
      [toggleButtons]="toggleButtons"
      (toggleActive)="onToggleActive($event)"
    ></eds-toggle>
  </div>
</ng-container>
